import { render, staticRenderFns } from "./Authorizer.vue?vue&type=template&id=30e40425&"
import script from "./Authorizer.vue?vue&type=script&lang=js&"
export * from "./Authorizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports